import React, { useState } from "react";

export default function DomesticShipping() {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const form = e.target;

    setTimeout(() => {
      setLoading(false);
      setDone(true);
      form.reset();
      setTimeout(() => setDone(false), 3000);
    }, 1500);
  };

  return (
    <>
      {/* ⭐ INLINE PREMIUM CSS */}
      <style>{`
        .banner {
          height: 350px;
          background: url('/slider4.jpg') center/cover no-repeat;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          text-align: center;
        }

        .banner::after {
          content: "";
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,0.55);
        }

        .banner h1 {
          z-index: 2;
          font-size: 50px;
          font-weight: 800;
        }

        .section {
          padding: 90px 0;
        }

        .glass-card {
          background: rgba(255,255,255,0.9);
          backdrop-filter: blur(12px);
          padding: 40px;
          border-radius: 22px;
          box-shadow: 0 12px 35px rgba(0,0,0,0.12);
          border: 1px solid rgba(0,0,0,0.08);
          animation: fadeUp 1s ease;
          margin-bottom: 60px;
        }

        .title {
          font-size: 34px;
          font-weight: 800;
          margin-bottom: 20px;
          position: relative;
        }

        .title::after {
          content: "";
          width: 90px;
          height: 5px;
          background: linear-gradient(90deg, #005eff, #f80b0b);
          position: absolute;
          bottom: -8px;
          left: 0;
          border-radius: 5px;
        }

        .text {
          font-size: 17px;
          color: #444;
          line-height: 1.9;
          margin-bottom: 18px;
        }

        .highlight {
          font-size: 18px;
          font-weight: 600;
          color: #005eff;
          margin-top: 15px;
        }

        .feature-box {
          padding: 22px;
          border-radius: 15px;
          background: white;
          box-shadow: 0px 10px 25px rgba(0,0,0,0.12);
          border-left: 6px solid #005eff;
          margin-bottom: 20px;
        }

        /* FORM SECTION */
        .shipping-form {
          background: white;
          padding: 45px;
          border-radius: 20px;
          box-shadow: 0px 18px 40px rgba(0,0,0,0.12);
          border: 1px solid rgba(0,0,0,0.06);
          animation: fadeUp 1s ease;
          margin-top: 70px;
        }

        .form-label {
          font-weight: 600;
          margin-bottom: 6px;
          color: #2b2b2b;
        }

        .form-control-custom,
        .form-select-custom {
          width: 100%;
          padding: 14px;
          border-radius: 12px;
          border: 1px solid #cfd6ff;
          font-size: 15px;
          transition: 0.25s ease;
        }

        .form-control-custom:focus,
        .form-select-custom:focus {
          border-color: #005eff;
          box-shadow: 0 0 8px rgba(0,94,255,0.35);
          outline: none;
        }

        .submit-btn {
          width: 100%;
          padding: 16px;
          background: linear-gradient(90deg, #005eff, #003fc8);
          color: #fff;
          font-size: 18px;
          font-weight: 700;
          border: none;
          border-radius: 14px;
          transition: 0.3s ease;
        }

        .submit-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0px 12px 22px rgba(0,94,255,0.35);
        }

        .loading-text {
          margin-top: 12px;
          color: #005eff;
          font-weight: 600;
        }

        .success-text {
          margin-top: 12px;
          color: green;
          font-weight: 600;
        }

        /* FAQ */
        .faq-box {
          background: #f8f9ff;
          padding: 18px;
          border-radius: 12px;
          margin-bottom: 12px;
          border-left: 4px solid #005eff;
        }

        @keyframes fadeUp {
          0% { opacity: 0; transform: translateY(25px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {/* ⭐ BANNER */}
      <div className="banner">
        <h1>Domestic Shipping</h1>
      </div>

      {/* ⭐ MAIN CONTENT SECTION */}
      <section className="section">
        <div className="container">

          {/* ⭐ OVERVIEW CARD */}
          <div className="glass-card">
            <h2 className="title">Fast, Secure & Nationwide Shipping Across the United States</h2>

            <p className="text">
              At SWIFTSHIP, domestic shipping is more than just moving a package from point A to point B — 
              it's about creating a smooth, transparent, and stress-free logistics experience for businesses 
              and individuals across America. Whether you're shipping one parcel or managing a nationwide 
              distribution network, we are here to deliver unmatched speed, accuracy, and reliability.
            </p>

            <p className="text">
              With our advanced routing technology, real-time tracking platform, and strong carrier partnerships, 
              SWIFTSHIP provides a domestic logistics system designed for efficiency. Our delivery network covers 
              all 50 states, ensuring timely pickups and fast transit times across urban, suburban, and rural zones.
            </p>

            <p className="text">
              Our domestic shipping services support small businesses, e-commerce brands, enterprise-level 
              distribution channels, healthcare, manufacturing, retail, and many other industries. Whether 
              you're shipping lightweight parcels or oversized freight, SWIFTSHIP ensures safe handling and 
              complete visibility throughout the entire journey.
            </p>

            <p className="highlight">Why Domestic Shipping Matters</p>

            <p className="text">
              The speed and reliability of your domestic logistics operations directly influence customer satisfaction,
              product quality, inventory turnover, and brand reputation. With SWIFTSHIP, businesses gain complete 
              control over their shipping workflow — ensuring predictable delivery timelines, reduced delays, 
              and an elevated customer experience.
            </p>

          </div>

          {/* ⭐ FEATURES SECTION */}
          <h2 className="title">Core Features of Domestic Shipping Service</h2>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Same-Day & Next-Day Delivery Nationwide</h5>
            <p className="text">
              We specialize in ultra-fast domestic delivery. In selected cities, you can schedule same-day pickups 
              with guaranteed delivery windows, ensuring your urgent shipments reach on time.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Real-Time Tracking from Pickup to Delivery</h5>
            <p className="text">
              Our tracking system provides real-time updates, delivery scans, route progress, estimated arrival time, 
              and SMS/email notifications for customers and businesses.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Secure Packaging & Zero-Damage Handling</h5>
            <p className="text">
              Each shipment is handled with industry-standard packing protocols, preventing damage during loading, 
              transit, sorting, or unloading.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Nationwide Pickup Coverage</h5>
            <p className="text">
              No matter where your business is based — Los Angeles, Phoenix, New York, Chicago, Miami, Dallas —  
              SWIFTSHIP can arrange pickups quickly and efficiently.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Cost-Optimized Routes</h5>
            <p className="text">
              We leverage AI-based routing and strategic carrier partnerships to reduce transit costs while maintaining 
              premium delivery standards.
            </p>
          </div>

          {/* ⭐ INDUSTRIES SERVED */}
          <h2 className="title mt-5">Industries We Serve</h2>

          <p className="text">Our domestic shipping service supports:</p>

          <ul className="text">
            <li>✔ E-commerce retailers</li>
            <li>✔ Small & medium-sized businesses</li>
            <li>✔ Enterprise-level supply chains</li>
            <li>✔ Healthcare & medical supply delivery</li>
            <li>✔ Manufacturing & automotive parts</li>
            <li>✔ Apparel & lifestyle brands</li>
            <li>✔ Electronics & high-value shipments</li>
            <li>✔ Food, beverages & perishables</li>
          </ul>

          {/* ⭐ FAQ SECTION */}
          <h2 className="title mt-5">Frequently Asked Questions</h2>

          <div className="faq-box">
            <strong>Q: How fast can you ship domestically?</strong>
            <p className="text">We offer same-day, next-day, express, and standard delivery options.</p>
          </div>

          <div className="faq-box">
            <strong>Q: Is my shipment insured?</strong>
            <p className="text">Yes, every shipment includes default coverage with optional extended insurance.</p>
          </div>

          <div className="faq-box">
            <strong>Q: Do you handle fragile shipments?</strong>
            <p className="text">Yes. We use reinforced packaging protocols for fragile or high-value items.</p>
          </div>

          <div className="faq-box">
            <strong>Q: Can I ship oversized freight?</strong>
            <p className="text">Absolutely. We support palletized freight and oversized domestic cargo.</p>
          </div>

          {/* ⭐ PREMIUM FORM SECTION */}
          <form className="shipping-form" onSubmit={handleSubmit}>
            <h3 className="fw-bold mb-4">Request a Domestic Shipping Quote</h3>

            <div className="row g-3">

              <div className="col-md-6">
                <label className="form-label">Full Name</label>
                <input type="text" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Phone Number</label>
                <input type="text" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Email Address</label>
                <input type="email" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Origin (From)</label>
                <input type="text" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Destination (To)</label>
                <input type="text" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Package Weight</label>
                <input type="text" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Number of Packages</label>
                <input type="number" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Shipment Type</label>
                <select className="form-select-custom" required>
                  <option value="">Select Type</option>
                  <option>Small Parcel</option>
                  <option>Pallet Freight</option>
                  <option>Oversized Cargo</option>
                  <option>Fragile / High Value</option>
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label">Delivery Speed</label>
                <select className="form-select-custom" required>
                  <option value="">Select Speed</option>
                  <option>Standard Delivery</option>
                  <option>Express Delivery</option>
                  <option>Same-Day Delivery</option>
                </select>
              </div>

              <div className="col-12">
                <label className="form-label">Additional Instructions</label>
                <textarea className="form-control-custom" rows="4"></textarea>
              </div>

            </div>

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? "Submitting..." : "Submit Request"}
            </button>

            {loading && <div className="loading-text">Please wait...</div>}
            {done && <div className="success-text">Your request has been submitted successfully!</div>}
          </form>

        </div>
      </section>
    </>
  );
}
